<template>
  <div :class="['form__field', {'--half': half}]">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: {
    half: {
      type: Boolean,
      required: true
    }
  }
}
</script>